/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 7/21/15.
 */
'use strict';
angular.module('prism-ui.components.data').directive('viewstatePermission', function (PermissionsService, $compile) {
	return {
		restrict: 'A',
		terminal: true,
		compile: function(ielement) {
			ielement.removeAttr('viewstate-permission');
			return function (scope, element, attrs) {
				var canRead = false;
				var canWrite = false;
				var applyException = false;
				var viewStateKey = attrs.viewstatePermission;
				var componentsToDisable = 'dropdown-select';

				/**
				 *  Intercepts click from element and does not allow click if user does not have canWrite permission
				 */
				var clickInterceptor = function (event) {
					event.stopImmediatePropagation();
				};

				/**
				 * Ensures that a change to the disabled attribute will not wipe out permission-based disabling.  This is
				 * useful for elements like buttons that are enabled when an item in a grid or list is selected.  This function
				 * will still keep the element disabled if the user does not have write permission.
				 */
				var ngDisabledChangeHandler = function(val) {
					var currentVal = scope.$eval(val);
					var disabled = (currentVal) || !canWrite || applyException;
					element.attr('ng-disabled', disabled);
					element.attr('disabled', disabled);
					element.find(componentsToDisable).attr('ng-disabled', disabled);
					element.find(componentsToDisable).attr('disabled', disabled);
				};

				/**
				 * Util PermissionsService to get read permission for the view state, then chains getting of the write
				 * permission, finally chaining determining if there is an exception.  Read Permission will determine rather
				 * or not the element will even be visible.  Write permission and an exception will disable/enable the element
				 * and also intercept the click of the element if the element has a click handler set.
				 */
				PermissionsService.canRead(viewStateKey).then(function (readPerm) {
					canRead = readPerm;
					if (readPerm) {
						element.show();
					} else {
						element.hide();
					}
					return PermissionsService.canWrite(viewStateKey);
				}).then(function (writePerm) {
					canWrite = writePerm;
					if (!attrs.disabled) {
						if (attrs.ngDisabled) {
							element.attr('ng-disabled', !canWrite  + '||' + attrs.ngDisabled);
						} else {
							element.attr('ng-disabled', !canWrite);
						}
					}
					if (!writePerm && element.attr('ng-click') || attrs.disabled) {
						scope.$watch(function() { return element.attr('ng-disabled');}, ngDisabledChangeHandler);
						element.off('click');
						element.on('click', clickInterceptor);
					}
					return PermissionsService.exceptionApplies(viewStateKey);
				}).then(function (exception) {
					applyException = exception;
					if(!attrs.disabled) {
						if(attrs.ngDisabled) {
							element.attr('ng-disabled', !canWrite + '||' + exception +  '||' + attrs.ngDisabled);
						} else {
							element.attr('ng-disabled', !canWrite || exception);
						}
					}
					if (exception && canWrite && element.attr('ng-click') || attrs.disabled) {
						scope.$watch(function() { return element.attr('ng-disabled');}, ngDisabledChangeHandler);
						element.off('click');
						element.on('click', clickInterceptor);
					}
					$compile(element)(scope);
				});
			};
		}
	};
});
